// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__110pg","col":"styles_col__257r2"};